/**
 * useCopyToClipboard - clipboard write with fallback + transient "copied" state
 *
 * Returns [copied, copy] where:
 *   copied  - true for 2 s after a successful copy
 *   copy    - call with the string to write
 */

import { useState } from 'react';

export function useCopyToClipboard(resetMs = 2000): [boolean, (text: string) => void] {
  const [copied, setCopied] = useState(false);

  const copy = (text: string) => {
    const fallback = () => {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    };

    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(text).catch(fallback);
    } else {
      fallback();
    }

    setCopied(true);
    setTimeout(() => setCopied(false), resetMs);
  };

  return [copied, copy];
}
